module.exports = ".spotlight.row .imagebox {\n  padding-left: 0;\n  padding-right: 0;\n  height: 423px;\n  background-position: center;\n  background-size: cover; }\n\n.spotlight.row .copybox {\n  text-align: center;\n  padding: 20px; }\n  .spotlight.row .copybox h1,\n  .spotlight.row .copybox h2 {\n    color: white; }\n  .spotlight.row .copybox div {\n    font-size: larger;\n    width: 70%;\n    margin: 0 auto; }\n\n.copybox .copy {\n  font-family: \"adelle\";\n  font-style: italic;\n  font-size: 3.0rem;\n  line-height: 1.4; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/components/content-builder/content-builder.style.scss
// module id = 749
// module chunks = 2